// src/features/counter/counterSlice.js
import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";
export const sendToAuditInfo = createAsyncThunk(
  "episodeStatus/sendToAuditInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        // "https://gub0w2lijl.execute-api.ap-southeast-2.amazonaws.com/dummy/send_to_audit_info",
        "/send_to_audit_info",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching send to audit info:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch data"
      );
    }
  }
);


const EpisodeStatusSlice = createSlice({
  name: "episodeSatus",
  initialState: {
   drgSelectedVersion: "",
    selectedDrgData: null,
     auditors: [],
    queues: [],

    hasMore: false,
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,

    queuesloading: false,
    error: null,
    clickedEpisodeQueues:[],
  },
  reducers: {
   storeDrgVersionAndData:(state,action) =>{
     state.drgSelectedVersion = action.payload.selectedVersion;
      state.selectedDrgData = action.payload.selectedDrgData;
   },
  setClickedEpisodeQueues:(state,action) =>{
    state.clickedEpisodeQueues = action.payload
  }
  },
   extraReducers: (builder) => {
    builder
      // ✅ PENDING
      .addCase(sendToAuditInfo.pending, (state) => {
        state.queuesloading = true;
        state.error = null;
      })

      // ✅ SUCCESS
      .addCase(sendToAuditInfo.fulfilled, (state, action) => {
        state.queuesloading = false;

        state.auditors = action.payload.auditors || [];
        state.queues = action.payload.queues || [];

        state.hasMore = action.payload.has_more;
        state.totalCount = action.payload.total_count;
        state.pageNumber = action.payload.page_number;
        state.pageSize = action.payload.page_size;
      })

      // ✅ FAILED
      .addCase(sendToAuditInfo.rejected, (state, action) => {
        state.queuesloading = false;
        state.error = action.payload;
      });
  },
 
});

export const {storeDrgVersionAndData,setClickedEpisodeQueues } = EpisodeStatusSlice.actions;
export default EpisodeStatusSlice.reducer;
